import Image from '../../Image'
import './index.less'
const YzEmptyMobile = ({
  marginTop,
  title='搜索结果-无数据',
  width='100%',
  height='100%',
  backgroundColor='#FFF',
  image=require('./assets/img_empty_data 1@2x.png')
}) => {
  return (
    <div 
      style={{
        marginTop: marginTop,
        width: width, height: height,
        backgroundColor: backgroundColor
      }}
      className='yz_mpty_m'
    >
      <div className='yz_mpty_m_box'>
        <Image src={image} alt='' />
        <span>{title}</span>
      </div>
    </div>
  )
}

export default YzEmptyMobile